const Content = ({ children }) => {
  return <div className="mx-auto max-w-7xl">{children}</div>;
};

export default Content;
